<template>
  <a-spin :spinning="spinning">
    <div style="padding: 24px;background: #fff;">
      <a-form layout="inline">
        <a-form-item
          label="当前菜品库页数"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input-search
            v-model="pageIndex"
            type="number"
            placeholder="请输入页码"
            @search="onPageChange"
            enterButton
          />
          共{{ bigFoodPage }}页----当前页未处理{{ noHandleCount }}个
        </a-form-item>
        <a-form-item
          label="大食材库"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-select
            labelInValue
            style="width: 420px"
            :defaultValue="bigFoodList[0].text"
            allowClear
            defaultActiveFirstOption
            v-model="bigMenuName"
            @change="bigChange"
          >
            <a-select-option
              v-for="(item, index) in bigFoodList"
              :value="item.text"
              :key="index"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="小食材库"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-auto-complete
            :dataSource="queryedFood"
            style="width: 400px"
            allowClear
            @select="onSelect"
            @search="onSearch"
            v-model="queryMenName"
            placeholder="输入食材名称"
          />
        </a-form-item>
        <a-form-item style="margin-left: 40px;">
          <a-button type="primary" @click="matching" :loading="loading"
            >匹配</a-button
          >
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="matchingMore" :loading="loading"
            >批量匹配</a-button
          >
        </a-form-item>
      </a-form>
      <div style="width:500px;margin:auto">
        <a-input-search
          placeholder="请输入食材名称"
          @search="onSearchMenu"
          v-model="keyword"
          enterButton
        />
        <a-checkbox @change="onCheckAll" v-show="menuList.length > 0">{{
          isCheckAll ? "全不选" : "全选"
        }}</a-checkbox>
        <div style="max-height:800px;overflow-y: auto;" id="menu-list">
          <!-- <a-checkbox
            v-for="item in menuList"
            :key="item"
            style="display:block;margin-left: 0px;"
          >{{item}}</a-checkbox>-->
          <a-checkbox-group :options="menuList" v-model="selectedMenu" />
        </div>
      </div>
    </div>
  </a-spin>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      baseUrl: 'http://188049k8k4.iok.la',
      pageIndex: 1,
      queryMenName: '',
      bigMenuName: '',
      bigFoodList: [{ id: -1, text: '没有了' }],
      bigFoodPage: 0,
      noHandleCount: 0,
      queryedFood: ['选我'],
      loading: false,
      spinning: false,
      timer: 0,
      keyword: '',
      menuList: [],
      selectedMenu: [],
      isCheckAll: false
    }
  },
  computed: {},
  mounted () {
    this.spinning = true
    this.getBigFoodList().then(res => {
      if (res.status === 200 && res.data.list.length) {
        this.bigFoodList = res.data.list
        this.noHandleCount = res.data.count
        console.log(res)
      }
      this.bigFoodPage = res.data.totalPage
      this.spinning = false
    })
  },
  watch: {
    isCheckAll: function (newV, oldV) {
      if (newV) {
        // eslint-disable-next-line no-unused-expressions
        this.selectedMenu
      }
      console.log(newV)
    }
  },
  methods: {
    bigChange (value) {
      this.queryMenName = value.key
      this.onSearch(value.key)
    },

    // 匹配
    matching () {
      if (this.bigMenuName.key === this.queryMenName) {
        this.$message.warning('小食材没选')
        return
      }

      if (this.bigMenuName.key && this.queryMenName) {
        let fd = new FormData()
        fd.append('nameZhuLiao', this.bigMenuName.key)
        fd.append('nameDiet', this.queryMenName)

        this.loading = true
        this.mathingFood(fd).then(res => {
          if (res.status === 200) {
            for (let i = 0; i < this.bigFoodList.length; i++) {
              const name = this.bigFoodList[i]
              if (name.text === this.bigMenuName.key) {
                this.bigFoodList.splice(i, 1)
                break
              }
            }
            this.noHandleCount = this.bigFoodList.length
            this.$message.success('添加成功')
          } else {
            this.$message.success('服务器错误')
          }
          this.loading = false
        })
      } else {
        this.$message.warning('不能为空')
      }
    },

    onPageChange () {
      this.bigMenuName = ''
      this.getBigFoodList({ pageIndex: this.pageIndex }).then(res => {
        if (res.status === 200) {
          this.bigFoodList = res.data.list
          this.noHandleCount = res.data.count
        }
      })
    },

    onSearch (value) {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getSmallFoodList({ name: value }).then(res => {
          this.queryedFood = ['选我']
          if (res.status === 200) {
            if (res.data && res.data.length > 0) {
              res.data.map(item => {
                this.queryedFood.push(item.text)
              })
            }
          }
        })
      }, 1000)
    },

    onSelect (value) {
      console.log(value)
    },

    // 获取大菜品库
    getBigFoodList (parameter) {
      return axios({
        url: `${this.baseUrl}/home/GetFood`,
        method: 'GET', // default
        params: {
          ...parameter
        }
      })
    },

    getSmallFoodList (parameter) {
      return axios({
        url: `${this.baseUrl}/home/GetDiet`,
        method: 'GET', // default
        params: {
          ...parameter
        }
      })
    },

    mathingFood (params) {
      return axios({
        url: `${this.baseUrl}/home/EditFood`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        },
        data: params
      })
    },

    onSearchMenu (parameter) {
      axios({
        url: `${this.baseUrl}/home/GetFoodList`,
        method: 'GET', // default
        params: {
          name: this.keyword
        }
      }).then(res => {
        if (res.status === 200) {
          console.log(res)
          this.menuList = res.data.list
        }
      })
    },

    // 全选，全部选
    onCheckAll (v) {
      this.isCheckAll = v.target.checked
      this.selectedMenu = v.target.checked ? this.menuList : []
    },
    /* onGroupChange(checkedValues) {
      console.log(checkedValues);
    } */

    matchingMore () {
      if (this.selectedMenu.length) {
        this.loading = true
        let fd = new FormData()
        fd.append('nameZhuLiaolist', JSON.stringify(this.selectedMenu))
        fd.append('nameDiet', this.queryMenName)

        axios({
          url: `${this.baseUrl}/home/BatchEditFood`,
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
          },
          data: fd
        }).then(res => {
          if (res.status === 200) {
            this.$message.success('匹配成功')
            this.selectedMenu.map(item => {
              for (let i = 0; i < this.menuList.length; i++) {
                const menu = this.menuList[i]
                if (item === menu) {
                  this.menuList.splice(i, 1)
                  break
                }
              }
            })
            this.selectedMenu = []
          } else {
            this.$message.error('服务器错误')
          }
          this.loading = false
        })
      } else {
        this.$message.warning('所选食材不能为空')
      }
    }
  }
}
</script>

<style lang="less">
#menu-list {
  .ant-checkbox-group-item {
    display: block !important;
    margin-right: 8px;
  }
}
</style>
